module.exports = __webpack_public_path__ + "img/bg_function06_1_t.ff1b7aef.png";